import React, { useEffect, useRef, useState } from 'react'
import logoBlack from '../../images/navbar/logo-black.png';
import { NavLink } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import './index.css';
import NavbarLogout from './navbar-logout';

const DashboardNavbar = ({ prefix }) =>
{
    const [prefixVal, setPrefixVal] = useState('');
    const [username, setUsername] = useState('');
    const [messageUrl, setMessageUrl] = useState('');
    const [jobsUrl, setJobsUrl] = useState('');
    const [homeUrl, setHomeUrl] = useState('');
    const [MobileToggle, setMobileToggle] = useState(false);
    const navRef = useRef(null);

    useEffect(() =>
    {
        setPrefixVal(window.location.href.includes('business') ? 'Biz ' : prefix);
        const token = localStorage.getItem('token');
        if (token !== null)
        {
            const decodeToken = jwtDecode(token);
            setUsername(decodeToken.UserName);
            setMessageUrl(decodeToken.UserType == "Business" ? 'business_messages' : 'home_messages');
            setJobsUrl(decodeToken.UserType == "Business" ? 'viewjob' : 'newhomejobs');
            setHomeUrl(decodeToken.UserType == "Business" ? 'businessdash' : '');
        }
        document.addEventListener('mousedown', handleClickOutside);
        return () =>
        {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [prefix]);

    const handleClickOutside = (event) =>
    {
        if (navRef.current && !navRef.current.contains(event.target))
        {
            setMobileToggle(false);
        }
    };

    return (
        <div>
            <header className="bsp-header">
                <nav className="navbar navbar-expand-sm navbar-dark">
                    <div className="container">
                        <NavLink className="navbar-brand" to="/">
                            <img src={logoBlack} alt="Logo" />
                        </NavLink>

                        <div className={`collapse navbar-collapse ${MobileToggle ? 'show' : ''}`} id="mynavbar">
                            <ul className="navbar-nav m-auto">
                                <li className="nav-item">
                                    <NavLink className="nav-link" to={`/${homeUrl}`}>Home</NavLink>
                                </li>
                                <li className="nav-item">
                                    <NavLink className="nav-link" to={`/${jobsUrl}`}>Jobs New</NavLink>
                                </li>
                                <li className="nav-item">
                                    <NavLink className="nav-link" to={`/${messageUrl}`}>Message</NavLink>
                                </li>
                                <li className="nav-item">
                                    <NavLink className="nav-link" to="/education-home">Education Hub</NavLink>
                                </li>
                                <li className="nav-item">
                                    <a 
                                        className="nav-link" 
                                        href="https://social.buildstart.au" 
                                        target="_blank" 
                                        rel="noopener noreferrer"
                                    >
                                        Social Platform
                                    </a>
                                </li>

                            </ul>

                        </div>

                        <div className='Mobile-toggle-wrapper'>
                            <NavbarLogout UserName={username} prefix={prefix} />
                            <button onClick={() => setMobileToggle(!MobileToggle)} className="navbar-toggler mobile-toggle" type="button">
                                <span></span>
                                <span></span>
                                <span></span>
                            </button>
                        </div>
                    </div>
                </nav>
            </header>
        </div>
    )
}

export default DashboardNavbar;
